import { signIn } from "../../api/index";
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';
const REDIRECT = 'REDIRECT';

const initState = {
  redirectTo: '',
  token: '',
  adminName: ''
};

export function user(state=initState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {...state, redirectTo: '/admin/dashboard', ...action.payload};
    case LOGOUT:
      return {token: '', redirectTo: '/admin'};
    case REDIRECT:
      return {redirectTo: action.payload.redirectTo};
    default:
      return state;
  }
}

function loginSuccess(data) {
  return {type: LOGIN_SUCCESS, payload: data};
}

export function login(data, header) {
  return dispatch=>{
    signIn(data, header)
      .then(res=>{
        if (res.status === "success") {
          dispatch(loginSuccess(res.data));
        }
        $("#submitBtn").button('reset');
      })
      .catch(e=>{
        console.log(e);
        $("#submitBtn").button('reset');
      });
  };
}

export function logout() {
  sessionStorage.clear();
  return {type: LOGOUT};
}

export function redirect(data) {
  return {type: REDIRECT, payload: data};
}


// WEBPACK FOOTER //
// ./src/redux/reducer/user.js